const ICONS = {
  success: 'fa-circle-check',
  info: 'fa-circle-info',
  error: 'fa-circle-exclamation',
  warning: 'fa-triangle-exclamation',
};

export default function Toast({ msg, type = 'info' }) {
  const icon = ICONS[type] || ICONS.info;
  return (
    <div className={`toast-item toast-${type}`}>
      <i className={`fa-solid ${icon}`} />
      {msg}
    </div>
  );
}
